import styled from 'styled-components';

const MainContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${props => props.theme.colors.greyTen};
    padding: 0px 80px;
    border: 1px solid ${props => props.theme.colors.borderGray};
    overflow: hidden;
`;

const TabsContainer = styled.div`
  margin: 20px 10px 0px 80px;
`;

const BreadCrumbContainer = styled.div`
    display: flex;
    flex: 1;
`;

const MenuContainer = styled.div`
    display: flex;
    gap: 10px;
`;

const Title = styled.h3`
    margin: 0;
`;

const TitleName = styled.h3`
    margin: 0;
    color: #2173FF;
    margin-left: 5px;
`;

const UserColumnContainer = styled.div`
  display: flex;
  gap: 20px;
`;

const UserColumn = styled.div`
  flex: 1;
`;

const MainColumn = styled.div`
  flex: 13;
  
  
`;


const SideColumn = styled.div`
  flex: 1;
  margin-top:30px;
  margin-right: 50px;
`;

export {
  MainContainer,
  TabsContainer,
  BreadCrumbContainer,
  MenuContainer,
  Title,
  TitleName,
  UserColumnContainer,
  UserColumn,
  MainColumn,
  SideColumn

};
